import React from 'react';
import { SvgIcon } from './svg-icon';

export const Upload = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM14 15V20H10V15H7L12 10.5L17 15H14Z" />
  </SvgIcon>
);
